var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99389 0.834961C10.3111 0.834961 10.6008 1.01504 10.7412 1.29949L13.1189 6.11728L18.4351 6.88774C18.7492 6.93326 19.0101 7.15323 19.1081 7.45508C19.2062 7.75692 19.1242 8.08824 18.8968 8.30961L15.0444 12.0596L15.9527 17.3549C16.0064 17.6677 15.8777 17.9838 15.6209 18.1702C15.3641 18.3566 15.0237 18.381 14.7429 18.233L9.99928 15.7333L5.24419 18.2334C4.96342 18.381 4.6232 18.3564 4.36657 18.17C4.10994 17.9835 3.98142 17.6675 4.03506 17.3549L4.94342 12.0596L1.09096 8.30961C0.863551 8.08824 0.781614 7.75692 0.879636 7.45508C0.977658 7.15323 1.23862 6.93326 1.5527 6.88774L6.86892 6.11728L9.24661 1.29949C9.38699 1.01504 9.67669 0.834961 9.99389 0.834961ZM9.99389 3.55127L8.16951 7.24793C8.04807 7.49398 7.8133 7.66449 7.54175 7.70384L3.46506 8.29467L6.42015 11.1712C6.61684 11.3626 6.70664 11.6386 6.66023 11.9092L5.96323 15.9724L9.61192 14.054C9.85495 13.9263 10.1453 13.9264 10.3882 14.0544L14.0242 15.9704L13.3276 11.9092C13.2811 11.6386 13.3709 11.3626 13.5676 11.1712L16.5227 8.29467L12.446 7.70384C12.1745 7.66449 11.9397 7.49398 11.8183 7.24793L9.99389 3.55127Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlineIcon);
export default __webpack_public_path__ + "static/media/StarOutlineIcon.a426c698facd9a35a45c3ffb86006299.svg";
export { ForwardRef as ReactComponent };